const academyReworkings = {
	main: 'Telafi dersleri',
	welcome: 'Hoş geldin, {{name}}!',
	startDescription: 'Telafi dersi için konum, grup ve program seçin.',
	studentRequired: 'Telafi dersi kaydı seçilen öğrenci için kullanılabilir.',
	location: 'Konum',
	group: 'Grup',
	program: 'Program',
	selectLocation: 'Önce bir konum seçin.',
	selectGroup: 'Önce bir grup seçin.',
	selectProgram: 'Kayıttan önce bir program seçin.',
	noOptions: 'Kullanılabilir seçenek yok',
	retry: 'Tekrar dene',
	book: 'Telafi dersine kaydol',
	bookDescription: 'En fazla üç ders seçin, ardından saat ve eğitmen belirleyin.',
	myBookings: 'Kayıtlarım',
	myBookingsDescription: 'Telafi dersi kayıtlarınız.',
	viewBooking: 'Ayrıntılar',
	bookingDetails: 'Kayıt ayrıntıları',
	bookingDate: 'Tarih',
	lesson: 'Ders',
	zoomId: 'Zoom ID',
	zoomAccessCode: 'Zoom erişim kodu',
	zoomLink: 'Zoom bağlantısı',
	miroLink: 'Miro bağlantısı',
	teacherComment: 'Eğitmen yorumu',
	studentComment: 'Yorumunuz',
	closeDetails: 'Kapat',
	noBookings: 'Henüz planlanmış telafi dersiniz yok.',
	cancellationHint: 'Kaydınızı başlangıçtan en az {{minutes}} dakika önce iptal edebilirsiniz.',
	cancelBooking: 'İptal et',
	cancelTitle: 'Bu kayıt iptal edilsin mi?',
	cancelDescription: '{{lesson}} · {{date}}. İptalden sonra derse tekrar kayıt olabilirsiniz.',
	cancellationUnavailable: 'İptal edilemiyor',
	cancellationBlocked:
		'Dersin başlamasına {{minutes}} dakikadan az kaldı. Yardım için konum yöneticinizle iletişime geçin.',
	keepBooking: 'Kaydı koru',
	confirmCancel: 'Evet, iptal et',
	understood: 'Anladım',
	online: 'Çevrimiçi',
	offline: 'Yüz yüze',
	chooseLessons: 'Hangi dersleri telafi etmek istersiniz?',
	lessonsHint: 'En fazla 3 kaçırılan ders seçin. Her oturum 20 dakika sürer.',
	noLessons: 'Bu program için telafi edilebilecek ders yok.',
	missedOn: 'Kaçırılan tarih: {{date}}',
	selectedLessons: 'Seçilen: {{count}} / 3',
	nextDays: 'Sonraki: günler',
	nextTime: 'Sonraki: saat',
	chooseDays: 'Uygun günleri seçin',
	daysHint:
		'Bir veya birden fazla gün seçin. Devam etmeden önce uygun saat sayısını görebilirsiniz.',
	selectDay: '{{date}} gününü seç',
	selectedDays: 'Seçilen gün: {{count}}',
	availableTimes: 'Uygun saat: {{count}}',
	noTimes: 'Uygun saat yok',
	dayNoSlots: 'Bu gün için uygun saat kalmadı. Başka bir gün seçmek için geri dönün.',
	selected: 'Seçildi',
	days: 'Günler',
	time: 'Saat',
	chooseTimes: 'Uygun saatleri seçin',
	timesHint: 'Seçtiğiniz günlerde {{count}} adet 20 dakikalık aralık seçin.',
	previousWeek: 'Önceki hafta',
	nextWeek: 'Sonraki hafta',
	currentWeek: 'Bu hafta',
	timeZone: 'Tüm saatler Kyiv saatine göredir.',
	bookingDeadline: 'Ders başlamadan {{hours}} saatten daha önce kayıt olun.',
	tutorsAvailable: 'Uygun eğitmen sayısı: {{count}}',
	selectTime: '{{date}}, {{time}} seç',
	noSlots: 'Bu hafta uygun 20 dakikalık aralık yok. Başka bir hafta deneyin.',
	selectedTimes: 'Seçilen saat: {{count}} / {{total}}',
	nextTutor: 'Sonraki: eğitmenler',
	chooseTutors: 'Eğitmenleriniz',
	tutorsHint:
		'Önce en düşük iş yüküne sahip eğitmen seçilir. Başka bir uygun eğitmen seçebilirsiniz.',
	tutor: 'Eğitmen',
	selectTutor: 'Bir eğitmen seçin.',
	nextConfirm: 'Sonraki: onay',
	confirmTitle: 'Kaydınızı onaylayın',
	partiallyBooked: 'Kaydedilen: {{count}}. Tekrar deneme yalnızca kalan dersleri kaydeder.',
	booked: 'Kaydedildi',
	phone: 'Telefon numarası',
	contactHint: 'Bu telefon numarası ve yorum seçilen her kayda eklenir.',
	stepProgress: 'Adım {{current}} / {{total}}',
	comment: 'Yorum (isteğe bağlı)',
	confirmBooking: 'Kaydı onayla',
	requestFailed: 'Kayıt yüklenemedi veya kaydedilemedi. Tekrar deneyin.',
	slotsChanged: 'Bazı saatler artık uygun değil veya kayıt süresi doldu. Başka bir saat seçin.',
	lessons: 'Dersler',
	dateTime: 'Tarih ve saat',
	confirmation: 'Onay',
	back: 'Geri',
};

export default academyReworkings;
